import React from 'react';

const Icon = ({
  size = 12,
  color = '#48B0FF',
}) => {
  return (
    <svg
      height={size}
      width={size}
      viewBox="4 4 40 40"
    >
      <path fill={color} d="M8.1 44V41H39.9V44ZM8.1 7V4H39.9V7ZM24.1 39.5 16.5 31.9 18.65 29.75 22.6 33.7V14.3L18.65 18.25L16.5 16.1L24.1 8.5L31.7 16.1L29.55 18.25L25.6 14.3V33.7L29.55 29.75L31.7 31.9Z" />
    </svg>
  );
};

export default Icon;
